import { CaptionStyles, CaptionLineConfig, HighlightTypeEnum } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const funky: Partial<CaptionStyles> = {
  theme_preset: 'funky',
  pageStyle: {
    color: '#ffffff',
    WebkitTextStrokeWidth: '8px',
    WebkitTextStrokeColor: '#000000',
    paintOrder: 'stroke'
  },
  wordStyle: {
    active: {
      color: '#ffffff'
    },
    inactive: {
      color: '#ffffff'
    },
    highlightType: HighlightTypeEnum.Text
  },
  letterStyle: undefined,
  font_location: getFontFullPath('LuckiestGuy-Regular.ttf'),
  caps: false,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    wordIn: TransitionInEffect.Spring
  }
};

export default funky;
